import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import DoanhNghiep from './doanh-nghiep';
import DoanhNghiepDetail from './doanh-nghiep-detail';
import DoanhNghiepUpdate from './doanh-nghiep-update';
import DoanhNghiepDeleteDialog from './doanh-nghiep-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={DoanhNghiepUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={DoanhNghiepUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={DoanhNghiepDetail} />
      <ErrorBoundaryRoute path={match.url} component={DoanhNghiep} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={DoanhNghiepDeleteDialog} />
  </>
);

export default Routes;
